<template>
    <div :class="{'trading-desk-container': true, 'fixed': fixedHeader}">
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">{{ $t("main-menu9") }}</span>
            </li>
        </ul>
        <v-layout column wrap fill-height>
            <div class="trading-desk-container1" v-if="mobileCheck">
                <div class="how-head">
                    <div class="container">
                        <h1 class="inner-page-title">Live Market</h1>
                    </div>
                    <div class="filter-wrapper-mobile" v-on:click="() => { filterModal = true }">
                        Filter
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Dropdown icons" clip-path="url(#clip0_1866_35519)">
                                <path id="Vector" d="M16.59 8.59375L12 13.1737L7.41 8.59375L6 10.0037L12 16.0037L18 10.0037L16.59 8.59375Z" fill="black" fill-opacity="0.88"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1866_35519">
                                    <rect width="24" height="24" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="mobile-wines-body">
                    <div class="mobile-wines-row" v-for="(item, index) in filteredItems" :key="index">
                        <div class="mobile-wines-name-container">
                            <div v-if="item.wineName">
                                <div class="mobile-wines-name" v-on:click="() => { goToWineDetails(item) }">
                                    {{ item.vintage }} {{ item.wineName }}
                                </div>
                            </div>
                            <div v-else>
                                <div class="mobile-wines-name" v-on:click="() => { goToWineDetails(item) }">
                                    {{ item.vintage }} {{ item.producerName }}
                                </div>
                            </div>
                        </div>
                        <div v-if="item.isEnPrimeur" class="wine-enprimeur-mobile">En Primeur</div>
                        <div class="mobile-wines-inner-row">
                            <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                            <div class="mobile-wines-vintage">{{ item.regionName }}, {{ item.appellation }}</div>
                        </div>
                        <div class="mobile-wines-inner-row mobile-wines-inner-row-colour">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('colour') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                <div class="winemarket-winecolor-img winemarket-winecolor-img-m"
                                     :class="parseInt(item.colorId) === 1 ? 'redwine' : (parseInt(item.colorId) === 2 ? 'whitewine' : 'champagne')"></div>
                                <div class="winecolor-tooltip">
                                    {{ parseInt(item.colorId) === 1 ? $t('red') : (parseInt(item.colorId) === 2 ? $t('white') : (parseInt(item.colorId) === 3 ? $t('rose') : $t('champagne'))) }}
                                </div>
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('case-size') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                {{ item.size }}l
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('best-sell') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                {{
                                    formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).replace(',', '.'))
                                }}
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('best-buy') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                {{
                                    formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).replace(',', '.'))
                                }}
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('last-trade') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                <div class="mobile-wines-inner-row-last-trade">{{
                                        item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.'))
                                    }}
                                </div>
                                <div class="winemarket-change winemarket-change-m"
                                     :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                    {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                    <div></div>
                                </div>
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row mobile-wines-inner-row-fav">
                            <div class="mobile-wines-div mobile-wines-label">{{ $t('my-account-menu2') }}</div>
                            <div class="mobile-wines-div mobile-wines-value">
                                <button v-on:click="(event) => toggleFav(event, item)"
                                        :class="item.isFavourite ? 'wine-star wine-star-m active' : 'wine-star wine-star-m'"></button>
                            </div>
                        </div>
                        <div class="mobile-wines-inner-row">
                            <div class="mobile-wines-div">
                                <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)"
                                        :disabled="checkWineSell(item)">{{ $t('sell') }}
                                </button>
                            </div>
                            <div class="mobile-wines-div mobile-wines-value">
                                <div class="btn-secondary market-btn ga4-buy-wine" v-on:click="() => selectWine(item, true)">
                                    {{ $t('buy') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trading-desk-container1" v-else>
                <div class="how-head">
                    <div class="container">
                        <h1 class="inner-page-title">Live Market</h1>

                        <div class="fixed-filter-container">
                            <div class="filter-wrapper">
                                <v-select
                                    :items="countries"
                                    :placeholder="$t('address15')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.countryId"
                                    v-on:change="getRegions"
                                ></v-select>

                                <v-select
                                    :items="regionsList"
                                    :placeholder="$t('region')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.regionId"
                                    class="padding-sm"
                                    v-on:change="getAppellationRegions"
                                ></v-select>

                                <v-select
                                    :items="appellationsList"
                                    :placeholder="$t('appellation')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.appellationId"
                                ></v-select>

                                <v-select
                                    :items="producersList"
                                    :placeholder="$t('wine')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.producerId"
                                    class="padding-sm"
                                ></v-select>

                                <v-select
                                    :items="vintageMap"
                                    :placeholder="$t('vintage')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.vintage"
                                ></v-select>

                                <v-select
                                    :items="wineColors"
                                    :placeholder="$t('colour')"
                                    item-text="value"
                                    item-value="id"
                                    v-model="filtersObj.colorId"
                                    class="padding-sm"
                                ></v-select>
                            </div>
                            <div class="filter-btns-wrapper text-right">
                                <div class="wine-type">
                                    <v-select
                                        :items="favOptions"
                                        placeholder="Favourites"
                                        item-text="value"
                                        item-value="id"
                                        v-model="selectedFavOption"
                                    ></v-select>
                                    <v-select
                                        :items="statusList"
                                        placeholder="Order type"
                                        item-text="value"
                                        item-value="id"
                                        v-model="selectedStatus"
                                        class="padding-sm"
                                    ></v-select>
                                    <v-radio-group v-model="wineType" row>
                                        <v-radio
                                            :label="$t('all-wines')"
                                            value="0"
                                            @change="updateWineMarket"
                                        ></v-radio>
                                        <v-radio
                                            label="En Primeur"
                                            value="1"
                                            @change="updateWineMarket"
                                        ></v-radio>
                                        <v-radio
                                            :label="$t('bottled')"
                                            value="2"
                                            @change="updateWineMarket"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                                <button class="btn-secondary filter-btn" v-on:click="applyFilter">{{ $t('apply') }}</button>
                                <button class="btn-secondary clear-filter" v-on:click="resetFilter">{{ $t('clear-filter') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wine-market-wrapper">
                    <v-data-table :headers="headers" :items="filteredItems" :search="search" :items-per-page="1000"
                                  hide-default-footer class="elevation-1 winemarket-table" :custom-sort="customSort">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td class="wineitem-td">

                                    <div v-if="item.wineName">
                                        <div class="d-flex align-items-center">
                                            <div class="wine-vintage-name" v-on:click="() => { goToWineDetails(item) }">
                                                {{ item.vintage }} {{ item.wineName }}
                                            </div>
                                            <div class="bid-offer-badge" :class="{ bid: item.hasBids, offer: item.hasOffers }" v-if="item.hasBids || item.hasOffers">
                                                <span v-if="item.hasBids">{{ $t('bid') }}</span>
                                                <span v-if="item.hasOffers">{{ $t('bo-offer') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="d-flex align-items-center">
                                            <div class="wine-vintage-name" v-on:click="() => { goToWineDetails(item) }">
                                                {{ item.vintage }} {{ item.producerName }}
                                            </div>
                                            <div class="bid-offer-badge" :class="{ bid: item.hasBids, offer: item.hasOffers }" v-if="item.hasBids || item.hasOffers">
                                                <span v-if="item.hasBids">{{ $t('bid') }}</span>
                                                <span v-if="item.hasOffers">{{ $t('bo-offer') }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="producer-info">
                                        <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                                        {{ item.regionName }}, {{ item.appellation }}
                                    </div>
                                    <div v-if="item.isEnPrimeur" class="wine-enprimeur">En Primeur</div>
                                </td>
                                <td class="text-right">
                                    <div class="winemarket-winecolor-img"
                                         :class="parseInt(item.colorId) === 1 ? 'redwine' : (parseInt(item.colorId) === 2 ? 'whitewine' : 'champagne')"></div>
                                    <div class="winecolor-tooltip">
                                        {{ parseInt(item.colorId) === 1 ? $t('red') : (parseInt(item.colorId) === 2 ? $t('white') : (parseInt(item.colorId) === 3 ? $t('rose') : $t('champagne'))) }}
                                    </div>
                                </td>
                                <td class="winesize-td text-right">
                                    {{ item.size }}l
                                    <div>&nbsp;</div>
                                </td>
                                <td class="text-right">
                                    {{
                                        formatPrice(item.sellPrice.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.'))
                                    }}
                                    <div>&nbsp;</div>
                                </td>
                                <td class="text-right">
                                    {{
                                        formatPrice(item.buyPrice.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.'))
                                    }}
                                    <div>&nbsp;</div>
                                </td>
                                <td class="text-right">
                                    {{
                                        item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).replace(',', '.'))
                                    }}
                                    <div class="winemarket-change"
                                         :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                                        {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                                        <div></div>
                                    </div>
                                </td>
                                <td>
                                    <button v-on:click="(event) => toggleFav(event, item)"
                                            :class="item.isFavourite ? 'wine-star active' : 'wine-star'"></button>
                                </td>
                                <td class="market-btn-col half-padding-right">
                                    <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)" :disabled="checkWineSell(item)">{{ $t('sell') }}
                                    </button>
                                </td>
                                <td class="market-btn-col half-padding-left no-padding-right">
                                    <div class="btn-secondary market-btn ga4-buy-wine" v-on:click="() => selectWine(item, true)">
                                        {{ $t('buy') }}
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <template slot="no-data">
                            <v-alert dense type="info" class="no-orders-info">There are no wines found based on your
                                criteria.
                            </v-alert>
                        </template>
                    </v-data-table>
                </div>
            </div>
        </v-layout>

        <v-dialog v-model="filterModal" max-width="767px">
            <v-card class="market-filter-modal-body">
                <v-card-title class="market-filter-modal-title">
                    <button class="market-filter-close-btn" v-on:click="() => { filterModal = false }"></button>
                    Filter
                    <button class="market-filter-apply-btn" v-on:click="() => { applyFilter(); filterModal = false; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_check">
                                <path id="Vector" d="M9.33333 14.2867L17.1733 6.44667C17.6956 5.92438 18.5429 5.92588 19.0633 6.45001C19.5812 6.97153 19.5797 7.81365 19.06 8.33334L9.33333 18.06L4.94937 13.687C4.42578 13.1647 4.42675 12.3163 4.95152 11.7952C5.4725 11.2779 6.3135 11.2785 6.83365 11.7967L9.33333 14.2867Z" fill="#004F7F"/>
                            </g>
                        </svg>
                    </button>
                </v-card-title>
                <v-card-text class="market-filter-modal-body-text">
                    <div class="filter-wrapper">
                        <v-select
                            :items="countries"
                            :placeholder="$t('address15')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.countryId"
                            v-on:change="getRegions"
                        ></v-select>

                        <v-select
                            :items="regionsList"
                            :placeholder="$t('region')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.regionId"
                            v-on:change="getAppellationRegions"
                        ></v-select>

                        <v-select
                            :items="appellationsList"
                            :placeholder="$t('appellation')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.appellationId"
                        ></v-select>

                        <v-select
                            :items="producersList"
                            :placeholder="$t('wine')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.producerId"
                        ></v-select>

                        <v-select
                            :items="vintageMap"
                            :placeholder="$t('vintage')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.vintage"
                        ></v-select>

                        <v-select
                            :items="wineColors"
                            :placeholder="$t('colour')"
                            item-text="value"
                            item-value="id"
                            v-model="filtersObj.colorId"
                        ></v-select>

                        <v-select
                            :items="favOptions"
                            placeholder="Favourites"
                            item-text="value"
                            item-value="id"
                            v-model="selectedFavOption"
                        ></v-select>

                        <v-select
                            :items="statusList"
                            placeholder="Order type"
                            item-text="value"
                            item-value="id"
                            v-model="selectedStatus"
                        ></v-select>

                        <v-radio-group v-model="wineType" row>
                            <v-radio
                                :label="$t('all-wines')"
                                value="0"
                                @change="updateWineMarket"
                            ></v-radio>
                            <v-radio
                                label="En Primeur"
                                value="1"
                                @change="updateWineMarket"
                            ></v-radio>
                            <v-radio
                                :label="$t('bottled')"
                                value="2"
                                @change="updateWineMarket"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <button class="btn-secondary clear-filter" v-on:click="resetFilter">{{ $t('clear-filter') }}</button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex';
import {AWines, AMarket, APortfolio, AUser, ACommon} from '~/store/actions';
import {GMarket, GWines, GPortfolio, GCommon} from '~/store/getters';
import DomInfo from '../../components/DomInfo';
import moment from "moment";

export default {
    name: "Winemarket",
    head: {
        title: 'Vindome fine wines market | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'home homev2'
        }
    },
    components: {
        DomInfo
    },
    data() {
        return {
            filtersObj: {
                vintage: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                ghostWineId: null,
                producerId: null,
                ghostProducerId: null,
                colorId: null,
                priceFrom: null,
                priceTo: null,
                isEnPrimeur: true,
                hasOffers: null,
                hasBids: null,
                isFavorites: null
            },
            countries: [
                {
                    id: 253, value: 'Argentina'
                },
                {
                    id: 44, value: 'Chile'
                },
                {
                    id: 72, value: 'France'
                },
                {
                    id: 102, value: 'Italy'
                },
                {
                    id: 198, value: 'Spain'
                },
                {
                    id: 225, value: 'United States'
                }
            ],
            wineColors: [
                {id: 1, value: 'Red'},
                {id: 2, value: 'White'},
                {id: 3, value: 'Champagne'}
            ],
            wineId: null,
            actionTypes: ['Buy', 'Sell'],
            selected1: "Filter",
            filterModal: false,
            perPage: 10,
            pageNumber: 1,
            favItems: [],
            search: '',
            totalTableWines: 0,
            wineList: [],
            scrollPosition: 0,
            fixedHeader: false,
            scrollingUp: false,
            cachedWines: [],
            isLogged: false,
            wineType: '1',
            statusList: [
                {text: 'All', value: 'All'},
                {text: 'Bid', value: 'Bid'},
                {text: 'Offer', value: 'Offer'},
            ],
            favOptions: [
                {text: 'All', value: 'All'},
                {text: 'Favourites', value: 'Favourites'},
            ],
            selectedStatus: '',
            selectedFavOption: '',
        }
    },
    computed: {
        ...mapGetters({
            wineItems: GMarket.GET_WINES,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            portfolioList: GPortfolio.GET_PORTFOLIO_WINE_LIST,
            wineInfo: GWines.GET_SELECTED_WINE_INFO,
            countriesList: GCommon.GET_COUNTRIES_LIST,
            regionsList: GCommon.GET_REGIONS_LIST,
            appellationsList: GCommon.GET_APPELLATIONS_LIST,
            producersList: GMarket.GET_PRODUCERS,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            mobileCheck: GCommon.GET_MOBILE_VERSION
        }),
        headers() {
            return [
                {text: this.$i18n.t('wine'), value: 'producerName', class: 'sticky-header wine-th'},
                {text: this.$i18n.t('colour'), align: 'right', value: 'colorId', class: 'sticky-header'},
                {text: this.$i18n.t('case-size'), align: 'right', value: 'size', class: 'sticky-header'},
                {text: this.$i18n.t('best-sell'), align: 'right', value: 'sellPrice', class: 'sticky-header'},
                {text: this.$i18n.t('best-buy'), align: 'right', value: 'buyPrice', class: 'sticky-header'},
                {text: this.$i18n.t('last-trade'), align: 'right', value: 'lastTradePrice', class: 'sticky-header'},
                {text: this.$i18n.t('my-account-menu2'), align: 'center', value: 'isFavourite', class: 'sticky-header', sortable: false},
                {text: '', value: 'buyWine', class: 'sticky-header', sortable: false},
                {text: '', value: 'sellWine', class: 'sticky-header', sortable: false}
            ]
        },
        investmentHeaders() {
            return [
                {text: 'Purchase date', align: 'left', sortable: false, value: 'wine.dateOn'},
                {text: 'Storage', value: 'warehouseName'},
                {text: 'Units', value: 'units'},
                {text: 'Purchase price', value: 'price'},
                {text: 'Profit', value: 'profit', sortable: false},
                {text: '', sortable: false}
            ]
        },
        vintageMap() {
            let allVintages = [];
            let allVintagesIndexes = [];
            this.cachedWines.forEach(item => {
                if (allVintagesIndexes.indexOf(item.vintage) === -1) {
                    let newVintage = {};
                    newVintage.id = item.vintage;
                    newVintage.value = item.vintage;
                    allVintages.push(newVintage);
                    allVintagesIndexes.push(item.vintage)
                }
            });
            allVintages.sort(function (a, b) {
                return a.value - b.value;
            });
            return allVintages
        },
        filteredItems() {
            return this.wineItems.map(item => {
                let isWineInFavourites = false;
                this.favWinesList.forEach(wine => {
                    if (item.wineId === wine.wineId && item.caseSizeId === wine.caseSizeId) {
                        isWineInFavourites = true;
                    }
                });
                return Object.assign({expanded: false, isFavourite: isWineInFavourites}, item);
            })
        }
    },
    methods: {
        ...mapActions({
            getWines: AMarket.GET_WINES,
            loadWines: APortfolio.LOAD_WINES
        }),
        formatPrice(price) {
            return `€ ${price}`
        },
        updateWineMarket() {
            setTimeout(() => {
                if (this.wineType === '0') {
                    this.filtersObj.isEnPrimeur = ''
                } else if (this.wineType === '1') {
                    this.filtersObj.isEnPrimeur = true
                } else {
                    this.filtersObj.isEnPrimeur = false
                }

                this.applyFilter()
            }, 0)
        },
        handleScroll() {
            if (window.scrollY > 99) {
                this.fixedHeader = true;
                this.scrollingUp = window.scrollY < this.scrollPosition;
                this.scrollPosition = window.scrollY;
            } else {
                this.fixedHeader = false;
                this.scrollingUp = false;
            }
        },
        applyFilter() {
            let selectedProducerId = this.filtersObj.producerId
            const findSelectedWineInList = this.producersList.find(el => el.id === selectedProducerId)

            if (findSelectedWineInList) {
                if (findSelectedWineInList.isWine) {
                    this.filtersObj.wineId = findSelectedWineInList.id
                    this.filtersObj.ghostWineId = findSelectedWineInList.id
                    this.filtersObj.ghostProducerId = null
                } else {
                    this.filtersObj.wineId = null
                    this.filtersObj.ghostWineId = null
                    this.filtersObj.producerId = findSelectedWineInList.id
                    this.filtersObj.ghostProducerId = findSelectedWineInList.id
                }
            }

            localStorage.setItem('livemarketFiltersObj', JSON.stringify(this.filtersObj));
            localStorage.setItem('livemarketWineType', this.wineType);

            this.getWines(this.filtersObj);
        },
        resetFilter() {
            this.filtersObj = {
                vintage: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                wineId: null,
                ghostWineId: null,
                producerId: null,
                ghostProducerId: null,
                colorId: null,
                priceFrom: null,
                priceTo: null,
                isEnPrimeur: '',
                hasOffers: null,
                hasBids: null,
                isFavorites: null
            };
            this.selectedStatus = ''
            this.selectedFavOption = ''

            this.wineType = '0';
            this.$store.dispatch(ACommon.RESET_ALL_REGIONS);
            localStorage.removeItem('livemarketFiltersObj');
            localStorage.removeItem('livemarketWineType');
            this.getWines(this.filtersObj);
        },
        goToLogin() {
            localStorage.setItem('login_path', window.location.pathname);
            this.$router.push(this.localePath({ path: '/login'}));
        },
        goToRegister() {
            this.$router.push(this.localePath({ path: '/register'}));
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index[0] === 'producerName') {
                    return !isDesc[0] ? a[a.wineName ? 'wineName' : 'producerName'].toLowerCase().localeCompare(b[b.wineName ? 'wineName' : 'producerName'].toLowerCase()) : b[b.wineName ? 'wineName' : 'producerName'].toLowerCase().localeCompare(a[a.wineName ? 'wineName' : 'producerName'].toLowerCase())
                } if (index[0] === 'colorId') {
                    let colors = {
                        1: 'red',
                        2: 'white',
                        3: 'champagne'
                    }

                    return !isDesc[0] ? colors[a[index]].toLowerCase().localeCompare(colors[b[index]].toLowerCase()) : colors[b[index]].toLowerCase().localeCompare(colors[a[index]].toLowerCase());
                } else if (index[0] === 'size'){
                    let bottleSizeA = a[index].split('x')[1].replace('l',''),
                        numBottlesA = parseInt(a[index].split('x')[0]),
                        bottleSizeB = b[index].split('x')[1].replace('l',''),
                        numBottlesB = parseInt(b[index].split('x')[0]);

                    if (bottleSizeA === bottleSizeB) {
                        if (!isDesc[0]) {
                            return numBottlesA - numBottlesB
                        } else {
                            return numBottlesB - numBottlesA
                        }
                    } else {
                        return !isDesc[0] ? bottleSizeA.localeCompare(bottleSizeB) : bottleSizeB.localeCompare(bottleSizeA)
                    }
                } else if (index[0] === 'sellPrice' || index[0] === 'buyPrice' || index[0] === 'lastTradePrice') {
                    if (!isDesc[0]) {
                        return a[index] - b[index]
                    } else {
                        return b[index] - a[index]
                    }
                }
            });
            return items;
        },
        goToWineDetails(item) {
            if (!this.isLogged) {
                this.$store.dispatch(AWines.GET_WINE_DETAILS_NOT_LOGGED, {
                    wineId: item.wineId,
                    caseSize: item.caseSizeId,
                    languageId: this.$i18n.locale
                }).then(() => {
                    this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.caseSizeId  + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-')}));
                })
            } else {
                this.wineId = item.wineId;
                this.$store.dispatch(AWines.SELECT_WINE_ID, {
                    wineId: item.wineId,
                    caseSize: item.caseSizeId,
                    languageId: this.$i18n.locale
                });
                this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                    this.$router.push(this.localePath({path: '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-')}));
                });
            }
        },
        selectWine(item, isBuy) {
            if (!this.isLogged) {
                this.$nuxt.$emit("showLoginModal", '');
                return;
            }

            this.wineId = item.wineId;
            this.$store.dispatch(AWines.SELECT_WINE_ID, {
                wineId: item.wineId,
                caseSize: item.caseSizeId,
                languageId: this.$i18n.locale
            });
            this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                this.$router.push(this.localePath({path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId}));
            });
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;
            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine}).then(() => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.filteredItems.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;
                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });
                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        formatDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format == null ? 'DD-MM-YYYY HH:mm' : format)
        },
        checkWineSell(wineObj) {
            let isSellAvailable = true;
            this.portfolioSummary.forEach(wine => {
                wine.portfolioSummary.map(item => {
                    if (item.wineId === wineObj.wineId && item.caseSizeId === wineObj.caseSizeId && item.owned > 0) {
                        isSellAvailable = false;
                        return false;
                    }
                })
            });
            return isSellAvailable
        },
        getRegions() {
            this.$store.dispatch(ACommon.GET_ALL_REGIONS, this.filtersObj.countryId);
            this.filtersObj.regionId = null
        },
        getAppellationRegions() {
            this.$store.dispatch(ACommon.GET_ALL_APPELLATIONS_REGION, this.filtersObj.regionId);
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    created() {
        this.$store.dispatch(ACommon.GET_ALL_COUNTRIES);
        this.$store.dispatch(ACommon.GET_ALL_APPELLATIONS);
        this.$store.dispatch(AMarket.GET_PRODUCERS);

        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;

            this.$store.dispatch(AUser.GET_USER_COMMISSION);
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY);
            this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(() => {
                this.loadWines({statusId: 1});
            });
        }).catch(() => {
            this.isLogged = false;
        });

        if (process.client && localStorage.getItem('livemarketFiltersObj')) {
            let obj = JSON.parse(localStorage.getItem('livemarketFiltersObj'));

            this.filtersObj = {
                vintage: obj.vintage,
                countryId: obj.countryId,
                regionId: obj.regionId,
                appellationId: obj.appellationId,
                producerId: obj.producerId,
                colorId: obj.colorId,
                priceFrom: obj.priceFrom,
                priceTo: obj.priceTo,
                isEnPrimeur: obj.isEnPrimeur,
                hasOffers: obj.hasOffers,
                hasBids: obj.hasBids,
                isFavorites: obj.isFavorites,
            };

            if (obj.hasOffers) {
                this.selectedStatus = 'Offer'
            } else if (obj.hasBids) {
                this.selectedStatus = 'Bid'
            }

            this.wineType = localStorage.getItem('livemarketWineType');
            this.$store.dispatch(ACommon.GET_ALL_REGIONS, this.filtersObj.countryId);
        }

        this.getWines(this.filtersObj);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        wineItems: {
            immediate: true,
            deep: true,
            handler(v) {
                if (v.length > 0) {
                    this.cachedWines = [...v]
                }
            }
        },
        selectedStatus: {
            immediate: true,
            deep: true,
            handler(v) {
                if (this.selectedStatus === 'Bid') {
                    this.filtersObj.hasBids = true
                    this.filtersObj.hasOffers = null
                }
                if (this.selectedStatus === 'Offer') {
                    this.filtersObj.hasOffers = true
                    this.filtersObj.hasBids = null
                }
                if (this.selectedStatus === 'All') {
                    this.filtersObj.hasOffers = null
                    this.filtersObj.hasBids = null
                }
            }
        },
        selectedFavOption: {
            immediate: true,
            deep: true,
            handler(v) {
                if (this.selectedFavOption === 'Favourites') {
                    this.filtersObj.isFavorites = true
                } else {
                    this.filtersObj.isFavorites = null
                }
            }
        }
    }
}
</script>

<style scoped>
.how-head {
    background: url('../../assets/redesign/live.png') no-repeat center center;
    height: 330px;
    background-size: cover;
    margin-top: 80px;
    position: relative;
}

.how-head .inner-page-title {
    padding-top: 60px;
    z-index: 2;
    position: relative;
    color: #FFFFFF;
    text-align: center;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
}
.v-data-table .sticky-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 7;
}

.scrolling-up .v-data-table .sticky-header {
    top: 32px;
}

.v-data-table .v-data-table__wrapper {
    overflow: unset;
}

.filter-btns-wrapper {
    position: relative;
    margin-top: 24px;
}

.wine-type {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
}

.wine-enprimeur {
    background: #CEA94B;
    text-align: center;
    width: 80px;
    height: 20px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-size: 12px;
    line-height: 13px;
    color: #FFFFFF;
    padding: 4px;
    margin-top: 5px;
    margin-bottom: 5px;
}

.wine-enprimeur-mobile {
    background: #CEA94B;
    text-align: center;
    width: 84px;
    height: 25px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 4px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.mobile-wines-body {
    padding: 0 10px;
}

.mobile-wines-inner-row-last-trade {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 19px;
    line-height: 120%;
    color: #000000;
}

.mobile-wines-name {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 19px;
    line-height: 23px;
    color: #404040;
    font-weight: 600;
    width: 100%;
}

.mobile-wines-name:active {
    color: var(--brand);
    -webkit-tap-highlight-color: var(--brand);
}

.mobile-wines-name:hover {
    color: var(--brand);
    -webkit-tap-highlight-color: var(--brand);
}

.mobile-wines-inner-row {
    display: flex;
    margin: 4px auto 8px;
}

.mobile-wines-vintage {
    display: inline-block;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 23px;
    color: #000000;
    font-style: normal;
    font-weight: normal;
}

.mobile-wines-label {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 160%;
    text-align: left;
    color: #B2B2B2;
    font-style: normal;
    font-weight: normal;
}

.mobile-wines-inner-row-fav {
    margin-bottom: 20px;
}

.mobile-wines-inner-row-fav .mobile-wines-label {
    line-height: 33px;
}

.mobile-wines-value {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 160%;
    text-align: right;
    color: #000000;
    font-style: normal;
    font-weight: normal;
}

.mobile-wines-row {
    padding: 15px 0;
    border-bottom: 1px solid #CCCCCC;
}

.mobile-wines-div {
    display: inline-block;
    width: 50%;
    vertical-align: top;
}

.mobile-wines-inner-row-colour .mobile-wines-div {
    line-height: 24px;
}

.mobile-line {
    line-height: 20px;
}

h3 {
    color: #707070;
    margin-bottom: calc(2 * var(--gutter));
}

.fixed-market-header {
    position: fixed;
    padding: calc(1.2 * var(--gutter)) calc(3 * var(--gutter)) 0;
    width: calc(100% - calc(5 * var(--gutter)));
    height: 270px;
    background: #fff;
    z-index: 9;
}

.price-range-wrapper {
    display: flex;
    position: relative;
}

.price-range-separator {
    position: absolute;
    left: 0;
    right: 0;
    margin: 30px auto 0;
    width: 5px;
    height: 1px;
    background: #757575;
}

.price-from {
    width: 80px;
}

.price-to {
    width: 100px;
}

.filter-wrapper {
    display: flex;
}

.padding-sm {
    padding-left: 16px;
    padding-right: 16px;
}

.clear-filter {
    text-align: center;
    background: transparent;
    border-radius: 8px;
    padding: 8px 16px;
    color: #004F7F;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    min-width: 88px;
    border: 1px solid #004F7F;
}

.clear-filter:hover {
    color: #ffffff;
}

.trading-desk-container {
    height: calc(100% - 413px);
}

.fixed-filter-container {
    width: 100%;
    padding: 16px;
    gap: 24px;
    height: 140px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
}

.trading-desk-container.fixed .fixed-filter-container {
    position: fixed;
    top: 80px;
    background: #ffffff;
    z-index: 10;
    padding: 10px calc(3 * var(--gutter)) 5px;
    left: 0;
    box-shadow: 0 5px 8px -2px #adadad;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
}

.trading-desk-container1 .v-card__text {
    height: 100%;
    padding-bottom: 0;
}

.loading-screen {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #FFF;
    z-index: 10;
}

.loading-gif {
    margin: 200px auto;
    width: 200px;
    height: 200px;
}

.winemarket-table {
    background-color: transparent;
    box-shadow: none !important;
}

.wine-market-wrapper {
    height: 100%;
    padding: 0 calc(3 * var(--gutter));
}

.winemarket-change {
    color: #b2b2b2;
    font-size: var(--fs-small);
    margin: 2px 0;
}

.winemarket-change.negative div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../../assets/price-low-10px.svg') no-repeat center;
}

.winemarket-change.positive div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../../assets/price-up-10px.svg') no-repeat center;
}

.winemarket-winecolor-img {
    height: 17px;
    position: relative;
    background: url('../../assets/rose.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.redwine {
    background: url('../../assets/red.png') no-repeat center right;
    background-size: contain;
}

.winemarket-winecolor-img.whitewine {
    background: url('../../assets/white.png') no-repeat center right;
    background-size: contain;
}

.winecolor-tooltip {
    height: 25px;
    color: #B2B2B2;
    font-size: var(--fs-small);
    font-weight: 300;
    border-radius: 5px;
    line-height: 25px;
    margin-top: 3px;
}

.wine-vintage-name {
    font-size: var(--fs-base);
    font-weight: 400;
}

.wine-vintage-name:hover {
    color: var(--brand);
    cursor: pointer;
}

.producer-info {
    color: #B2B2B2;
    font-size: var(--fs-small);
    font-weight: 300;
}

.v-data-table tr:hover,
.v-data-table td:hover {
    cursor: pointer;
}

.market-btn-col {
    width: 100px;
}

.half-padding-left {
    padding-left: calc(0.5 * var(--gutter));
}

.no-padding-right {
    padding-right: 0 !important;
}

.half-padding-right {
    padding-right: calc(0.5 * var(--gutter));
}

.country-flag {
    width: 30px;
    height: 15px;
    display: inline-block;
    top: 1px;
    margin-right: 5px;
    position: relative;
    background-size: contain !important;
}

.wine-star {
    background: url('../../assets/star-not-selected.svg') no-repeat center;
    width: 33px;
    height: 33px;
    display: block;
    margin: 0 auto;
    background-size: contain;
}

.wine-star:focus,
.wine-star:active {
    outline: none;
}

.wine-star.active,
.wine-star:hover {
    background: url('../../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}

.wine-star.active:hover {
    opacity: 0.8;
}

.table-row-collapsed {
    width: 11px;
    height: 7px;
    background: url('../../assets/sprite-web.png') no-repeat -74px -712px;
}

.market-btn {
    width: 125px;
    font-weight: 300;
    text-align: center;
    line-height: 1em;
    height: 32px;
}

.filter-btn {
    text-align: center;
    background: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    color: #ffffff;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    min-width: 88px;
    border: 0;
}

.wine-details-shortdesc {
    background: #ffffff;
    border: 1px solid #E6E6E6;
    color: #000000;
    padding: 30px 15px;
    height: 270px;
    font-size: 16px;
    font-weight: 300;
    font-family: 'Roboto', sans-serif;
}

.no-orders-info {
    background: #F6F6F6 !important;
    color: #000000;
    text-align: center;
    height: 270px;
    font-size: 20px;
    font-weight: 300;
    line-height: 270px;
    margin: 32px -16px;
}

.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}

.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}

.btn-login {
    background: #004f7f;
    border-color: #004f7f;
}

.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}

.btn-bid-cancel:hover {
    color: #ffffff;
}

.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}

.bids-offers-modal .warning-icon {
    background: url('../../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.bids-title svg {
    margin-right: 5px;
    fill: #707070;
}

.offers-title svg {
    margin-right: 5px;
    fill: #707070;
}

.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}

.winemarket-winecolor-img-m {
    margin-left: 10px;
    margin-right: 10px;
    height: 15px;
    display: inline-block;
    width: 10px;
}

.wine-last-traded-price-m {
    line-height: 20px;
    position: relative;
}

.wine-star-m {
    float: right;
}

.bid-offer-badge {
    width: 48px;
    height: 15px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0px 8px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    border: 1px solid transparent;
    margin-left: 10px;
}

.align-items-center {
    align-items: center;
}

.bid-offer-badge span {
    width: 100%;
    text-align: center;
}

.bid-offer-badge.bid {
    background: #004F7F;
    color: #FFF;
    border: 1px solid #004F7F;
}

.bid-offer-badge.offer {
    background: transparent;
    color: #004F7F;
    border: 1px solid #004F7F;
}

@media (max-width: 767px) {
    .how-head {
        margin-top: 0;
        height: 300px;
    }
    .how-head .inner-page-title {
        padding-top: 28px;
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 72px;
    }
    .filter-wrapper-mobile {
        height: 74px;
        padding: 16px;
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.90);
        margin: 0 16px;
        line-height: 42px;
    }
    .filter-wrapper-mobile svg {
        position: relative;
        top: 8px;
        float: right;
    }
    .market-filter-modal-body {
        padding: 16px;
    }
    .v-dialog > .v-card > .v-card__text.market-filter-modal-body-text {
        padding: 0;
    }
    .filter-wrapper {
        display: block;
    }
    .filter-wrapper .v-input {
        margin-bottom: 12px;
    }
    .v-dialog > .v-card > .v-card__title.market-filter-modal-title {
        padding: 0;
        text-align: center;
        width: 100%;
        display: block;
        position: relative;
    }
    .market-filter-close-btn {
        background: url('../../assets/ui_close.png ') no-repeat center;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
    }
    .market-filter-apply-btn {
        position: absolute;
        right: 0;
    }
    .clear-filter {
        width: 100%;
        text-transform: uppercase;
        font-size: 14px;
        padding: 16px;
        height: 49px;
        line-height: 16px;
    }
    .country-flag {
        display: inline-block;
        width: 21px;
        height: 12px;
    }

    .trading-desk-container {
        padding: 80px 0 30px;
    }

    .winecolor-tooltip {
        display: inline-block;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        line-height: 160%;
        font-style: normal;
        font-weight: normal;
        color: #000000
    }

    .best-buy {
        height: 40px;
        line-height: 40px;
    }

    .winemarket-change {
        font-family: Roboto, sans-serif;
        font-size: 16px;
        line-height: 160%;
        font-style: normal;
        font-weight: normal;
        color: #B2B2B2;
    }

    .market-btn {
        width: calc(100% - 8px);
    }
}
</style>
<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions {
    justify-content: center;
}

.no-orders-info .v-alert__icon.v-icon {
    display: none;
}

html {
    overflow-y: auto;
}

.trading-desk .v-main {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}


.filter-wrapper .v-text-field,
.wine-type .v-text-field {
    padding-top: 0;
}
.footer-info-text {
    color: #A9B9C6;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    display: inline-block;
}

.footer-info-text div {
    display: inline-block;
    margin-right: 25px;
}

.trading-desk .vindome-container {
    background: #f7f8f9;
    padding: 0;
}

.show-hide-ctrl-options .accent--text {
    color: #024e7b !important;
    caret-color: #024e7b !important;
}

.theme--light.v-data-table thead tr th {
    font-weight: 500;
    font-size: 14px;
    color: #303344;
    letter-spacing: +0.28px;
}

.theme--light.v-data-table tbody tr td {
    font-weight: 300;
    font-size: var(--fs-base);
    color: #666F74;
    letter-spacing: +0.16px;
}

.winemarket-wine-filter.v-input input {
    max-height: 36px;
}

.winemarket-wine-filter .v-input__icon {
    padding-right: 15px;
}

.winemarket-table .v-data-table__wrapper {
    height: 100%;
}

.show-hide-ctrl-options .v-list-item--link {
    min-height: 28px;
}

.show-hide-ctrl-options .v-list-item__content {
    padding: 0;
}

.show-hide-ctrl-options .v-input--selection-controls,
.show-hide-ctrl-options .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin: 0;
    padding: 0;
}

.show-hide-ctrl-options .v-input--selection-controls .v-messages {
    display: none;
}

.v-data-table td.wineitem-td {
    width: 350px;
    color: #000000 !important;
    padding-left: 0 !important;
}

.theme--light.v-data-table.winemarket-table thead th {
    color: #b2b2b2 !important;
    font-size: var(--fs-small);
    font-weight: 300;
    box-shadow: none !important;
    height: 50px;
    padding-top: 20px;
    white-space: nowrap;
}

.theme--light.v-data-table.winemarket-table thead th:hover {
    color: var(--brand) !important;
}

.theme--light.v-data-table.winemarket-table thead th.wine-th {
    padding-left: 0;
}

.theme--light.v-data-table.winemarket-table tbody tr {
    border: 0;
    background: #ffffff;
    height: 60px;
    margin-bottom: 5px;
    border-radius: 5px;
}

.theme--light.v-data-table.winemarket-table tbody tr.additional-table-row:hover {
    background: #ffffff !important;
}

.theme--light.v-data-table.winemarket-table tbody tr td {
    border-bottom: 1px solid #b2b2b2;
}

.theme--light.v-data-table.winemarket-table tbody tr td.additional-table-row-td {
    padding: 0;
}

.theme--light.v-data-table .v-data-table-header th.sortable[aria-sort="none"] .v-icon {
    display: none;
}

.filter-wrapper .theme--light.v-input:not(.v-input--is-disabled) input,
.wine-type .theme--light.v-input:not(.v-input--is-disabled) input {
    border-bottom: 0;
    background-color: transparent;
}

.price-to .v-input__slot {
    padding-left: 20px;
}

.price-to .v-icon.v-icon,
.price-from .v-icon.v-icon {
    font-size: var(--fs-base);
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row):not(.v-data-table__empty-wrapper) {
    background: transparent;
}

.theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
    border-color: var(--brand) !important;
}

.v-select__slot .v-input__icon {
    background: url('../../assets/expand_more-24px.svg') no-repeat center;
    opacity: 0.4;
}

.v-select__slot .v-input__icon .v-icon {
    display: none;
}

.price-from.v-text-field .v-input__prepend-inner,
.price-to.v-text-field .v-input__prepend-inner {
    background: url('../../assets/euro-sign.svg') no-repeat center;
}

.price-from .v-input__icon .v-icon,
.price-to .v-input__icon .v-icon {
    display: none;
}

.filter-wrapper .v-text-field__details,
.wine-type .v-text-field__details {
    display: none;
}

.v-application .wine-type .accent--text {
    color: #000 !important;
    caret-color: #000 !important;
}

.wine-type .v-input--selection-controls {
    margin-top: 5px;
    margin-left: 16px;
}
.wine-type .v-label {
    font-size: 14px;
    line-height: 125%;
}
.v-data-table .sticky-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 7;
}

.scrolling-up .v-data-table .sticky-header {
    top: 32px;
}

@media (max-width: 767px) {
    .filter-wrapper .v-input--radio-group--row .v-input--radio-group__input,
    .wine-type .v-input--radio-group--row .v-input--radio-group__input {
        display: block;
    }
    .filter-wrapper .v-input--radio-group.v-input--radio-group--row .v-radio,
    .wine-type .v-input--radio-group.v-input--radio-group--row .v-radio {
        margin-bottom: 16px;
    }
}
</style>
